module.exports = __webpack_public_path__ + "static/media/leavesnew.c3309815.svg";